import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import api from '../../api/axios';
import { useAuth } from '../../context/AuthContext';
import { StatusBadge, PriorityBadge } from '../../components/StatusBadge';

const SupportDashboard = () => {
  const { user } = useAuth();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/api/support/tickets/assigned/${user.userId}`)
      .then(res => setTickets(res.data))
      .finally(() => setLoading(false));
  }, [user.userId]);

  const open = tickets.filter(t => t.status === 'OPEN').length;
  const inProgress = tickets.filter(t => t.status === 'IN_PROGRESS').length;
  const resolved = tickets.filter(t => t.status === 'RESOLVED').length;

  return (
    <div className="min-h-screen bg-gray-50">
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Support Dashboard</h1>
          <p className="text-gray-500 text-sm">Welcome, {user.name}</p>
        </div>

        <div className="grid grid-cols-4 gap-4 mb-8">
          {[
            { label: 'Total Assigned', value: tickets.length, color: 'bg-blue-50 text-blue-700' },
            { label: 'Open', value: open, color: 'bg-amber-50 text-amber-700' },
            { label: 'In Progress', value: inProgress, color: 'bg-indigo-50 text-indigo-700' },
            { label: 'Resolved', value: resolved, color: 'bg-green-50 text-green-700' },
          ].map(s => (
            <div key={s.label} className={`rounded-xl p-5 ${s.color}`}>
              <p className="text-sm font-medium opacity-70">{s.label}</p>
              <p className="text-3xl font-bold mt-1">{s.value}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
            <h2 className="font-semibold text-gray-700">My Assigned Tickets</h2>
            <Link to="/support/tickets" className="text-sm text-primary hover:text-primary-dark">View All →</Link>
          </div>
          {loading ? (
            <div className="text-center py-8 text-gray-400">Loading...</div>
          ) : tickets.length === 0 ? (
            <div className="text-center py-8 text-gray-400">No tickets assigned</div>
          ) : (
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  {['Ticket ID', 'Enterprise', 'KAM', 'Priority', 'Status', 'Created', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {tickets.slice(0, 10).map(t => (
                  <tr key={t.ticketId} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium text-primary">{t.ticketId}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{t.enterpriseName}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">{t.kamName}</td>
                    <td className="px-4 py-3"><PriorityBadge priority={t.priority} /></td>
                    <td className="px-4 py-3"><StatusBadge status={t.status} /></td>
                    <td className="px-4 py-3 text-xs text-gray-400">
                      {t.createdAt ? new Date(t.createdAt).toLocaleDateString() : '-'}
                    </td>
                    <td className="px-4 py-3">
                      <Link to={`/support/tickets/${t.ticketId}`}
                        className="text-xs text-primary font-medium hover:text-primary-dark">Resolve</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupportDashboard;
